import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegistrationOneClickModel } from '../models/registration_one_click_model';
import { SchedulerModel } from '../../course_scheduler/models/scheduler_model';

export type ShowRegisterButtonAfterPrecheckPassCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'showRegisterButtonAfterPrecheckPassCommand',
    (
      defineCommandORM: IDefineCommand,
      ngRegistrationOneClickModel: RegistrationOneClickModel,
      ngSchedulerModel: SchedulerModel
    ) =>
      defineCommandORM('showRegisterButtonAfterPrecheckPassCommand', (deferred) => {
        ngRegistrationOneClickModel.write({
          showRegisterButton: _4.get(ngSchedulerModel.read(), 'precheck_pass', false)
        });

        return deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/commands/show_register_button_after_precheck_pass_command.ts